var angular = require('angular'),
    services = require('../services/');

module.exports = angular.module('agada.directives', [services])
    .directive('elemReady', ['$parse', function ($parse) {
        return {
            restrict: 'A',
            link: function (scope, elem, attrs) {
                elem.ready(function () {
                    scope.$eval(attrs.elemReady);
                })
            }
        }
    }])
    .directive('clickOutside', ['$document', '$parse', function ($document, $parse) {
        return {
            restrict: 'A',
            link: function ($scope, elem, attr) {
                var classList = (attr.outsideIfNot !== undefined) ? attr.outsideIfNot.replace(', ', ',').split(',') : [],
                    fn = $parse(attr['clickOutside']);

                // add the elements id so it is not counted in the click listening
                if (attr.id !== undefined) {
                    classList.push(attr.id);
                }

                var eventHandler = function (e) {

                    //check if our element already hiden
                    if (angular.element(elem).hasClass("ng-hide")) {
                        return;
                    }

                    var i = 0,
                        element;

                    // if there is no click target, no point going on
                    if (!e || !e.target) {
                        return;
                    }

                    // loop through the available elements, looking for classes in the class list that might match and so will eat
                    for (element = e.target; element; element = element.parentNode) {
                        var id = element.id,
                            classNames = element.className,
                            l = classList.length;

                        // loop through the elements id's and classnames looking for exceptions
                        for (i = 0; i < l; i++) {
                            // check for id's or classes, but only if they exist in the first place
                            if ((id !== undefined && id.indexOf(classList[i]) > -1) || (classNames && classNames.indexOf(classList[i]) > -1)) {
                                // now let's exit out as it is an element that has been defined as being ignored for clicking outside
                                return;
                            }
                        }
                    }

                    // if we have got this far, then we are good to go with processing the command passed in via the click-outside attribute
                    return $scope.$apply(function () {
                        return fn($scope);
                    });
                };

                // assign the document click handler to a variable so we can un-register it when the directive is destroyed
                $document.on('click', eventHandler);

                // when the scope is destroyed, clean up the documents click handler as we don't want it hanging around
                $scope.$on('$destroy', function () {
                    $document.off('click', eventHandler);
                });
            }
        };
    }])
    .directive('checkImage', ['$http', function ($http) {
        return {
            restrict: 'A',
            link: function (scope, element, attrs) {
                element.bind('error', function () {
                    element.attr('src', require('../../img/headerIcons/sefer-agada.svg'));
                })
                attrs.$observe('ngSrc', function (ngSrc) {
                    if (ngSrc) element.addClass('MyClass');
                });

            }
        };
    }])
    .directive('ngRepeatDone', function () {
        return function (scope, element, attrs) {
            if (scope.$last) {
                // iteration is complete, do whatever post-processing
                // is necessary
                scope.$eval(attrs.ngRepeatDone);
            }
        };
    })
    .directive('dropStickHeader', ["$window", "$state", function ($window, $state) {
       return {
           link: function (scope, element, attrs) {
               angular.element($window).bind('scroll', function () {
                   var scrolltop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;

                   if (!scope.scrollPassedHeader.visiable && (scrolltop > 130)) {
                       scope.scrollPassedHeader.visiable = true;
                   }
                   else if (scope.scrollPassedHeader.visiable && (scrolltop < 130)) {
                       scope.scrollPassedHeader.visiable = false;
                   }
                   scope.$apply();
               });
           }
       };
   }])
    .directive('infiniteScroll', ["$window", "$state", "$rootScope", function ($window, $state, $rootScope) {

        return {
            link: function (scope, element, attrs) {
                function scrollHandler() {
                    var scrollTop = 0;
                    if (document.documentElement)
                        scrollTop = document.documentElement.scrollTop ? document.documentElement.scrollTop : body.scrollTop;

                    if (scope.getMore.loadMore && ((scrollTop + window.innerHeight) / body.scrollHeight >= 0.85) &&
                        (($state.$current.views['content@'] && $state.$current.views['content@'].controller == 'mainPageCtl') || $state.$current.views['content@'].controller == 'searchResultsCtl' || $state.$current.views['content@'].controller == 'mainPageKidsCtl')) {
                        scope.getMore.loadMore = false;
                        scope.$eval(attrs.infiniteScroll);
                    }
                }
                var body = angular.element(document).find('body')[0];
                angular.element($window).on('scroll', scrollHandler);

                scope.$on('$destroy', function () {
                    angular.element($window).off('scroll', scrollHandler)
                });

            }
        };
    }])
    .directive('changeScreenState', ["$window", "$rootScope", 'MOBILE_STATE', 'TABLET_STATE', 'NORMAL_STATE', function ($window, $rootScope, MOBILE_STATE, TABLET_STATE, NORMAL_STATE) {
        return {
            restrict: 'A',
            link: function (scope) {
                $window.onresize = function () {
                    changeState();
                    scope.$apply();
                };
                changeState();

                function changeState() {
                    var screenWidth = $window.innerWidth;
                    // console.log("---------------------------------");
                    // console.log(screenWidth, $rootScope.screenState);
                    if (1200 < screenWidth) {
                        if ($rootScope.screenState != NORMAL_STATE) {
                            $rootScope.screenState = NORMAL_STATE;
                            $rootScope.isMobile = false;
                            // console.log('NORMAL_STATE');
                        }
                    } else if (screenWidth < 768) {
                        if ($rootScope.screenState != MOBILE_STATE) {
                            $rootScope.screenState = MOBILE_STATE;
                            $rootScope.isMobile = true;
                            // console.log('MOBILE_STATE');
                        }
                    } else if ($rootScope.screenState != TABLET_STATE) { /* 768 <= screenWidth && screenWidth <=1200 */
                        $rootScope.screenState = TABLET_STATE;
                        $rootScope.isMobile = false;
                        // console.log('TABLET_STATE');
                    }
                    // console.log(screenWidth, $rootScope.screenState);
                    // console.log("---------------------------------");
                }
            }
        }
    }])
    .directive('dropDown', ["$window", '$parse', function ($window, $parse) {
        return {
            restrict: "E",
            scope: true,
            replace: true,
            template: require('../../views/modals/dropdown.html'),
            require: '?ngModel',
            link: function (scope, element, attr, ngModel) {
                if (!ngModel) return; // do nothing if no ng-model            
                scope.list = [];
                scope.options = angular.extend({ caption: "name", value: "tid" }, scope.$eval(attr.options));
                scope.options.caption = scope.options.caption ? $parse(scope.options.caption) : angular.identity;
                scope.options.value = scope.options.value ? $parse(scope.options.value) : angular.identity

                var $caption = element.find('span'),
                    $i = $caption.find('i');

                function setText(txt) {
                    $caption.html(txt.toString());
                    $i.appendTo($caption);
                    element.removeClass('placeholder open');
                }

                var un = scope.$watch(attr.list, function (n) {
                    scope.list = n || [];
                    ngModel.$render();
                    if (n) un();
                })

                ngModel.$render = function () {
                    for (var k in scope.list) {
                        if (angular.equals(scope.options.value(scope.list[k]), ngModel.$viewValue)) {
                            setText(scope.options.caption(scope.list[k]));
                            return;
                        }
                    }

                    if (attr.placeholder) {
                        setText(attr.placeholder);
                        element.addClass('placeholder');
                    }
                };

                element
                    .on('click', '.options div', function (e) {
                        e.preventDefault();
                        e.stopPropagation();
                        var $this = $(this);

                        setText($this.html());

                        scope.$evalAsync(function () {
                            ngModel.$setViewValue($this.data('value'));
                        });
                    })
                    .on('click', function () {
                        if (scope.$eval(attr.ngDisabled)) return false;
                        element.toggleClass('open');
                        //close other dropdowns open
                        if ($('.advSearch').find('.open').length > 0) {
                            $('.advSearch').find('.open').not(this).removeClass('open');
                        }                      
                    })

            }
        }
    }])
    .directive('audioPlayer', ['$window', '$timeout', '$rootScope', 'AUDIO_PATH', 'Player', function ($window, $timeout, $rootScope, AUDIO_PATH, Player) {
        return {
            restrict: "E",
            replace: true,
            transclude: true,
            template: require('../../kids/views/audioPlayer.html'),
            link: function (scope, element, attr, ctrl, transclude) {
                var myPlayer;
                var interval = null;
                scope.pl = { show: false, enabled: true };
                setPlayer();

                scope.showPlayer = function () {
                    if (interval) clearInterval(interval);
                    scope.progress = -6;
                    scope.pl.show = !scope.pl.show;
                    if (scope.pl.show) setPlayer();
                    if (!scope.pl.show) scope.stopAudio();
                }

                function getDuration() {
                    scope.totalDuration = myPlayer.formatTime(Math.round(myPlayer.howl.duration()));//sometimes getting 0 check why
                    scope.currentDuration = myPlayer.formatTime(0);
                }

                function setPlayer() {
                    var sound;
                    sound = AUDIO_PATH + attr.filename;
                    myPlayer = new Player(sound).onStateChange(function (state) {
                            scope.playing = (state === 'play');
                            if (state.error) scope.pl.enabled = false;
                            if (state === 'loaded') {
                                getDuration();
                            }
                    })
                }

                scope.playAudio = function () {
                    if (!myPlayer) setPlayer();
                    myPlayer.play();
                    scope.totalDuration = myPlayer.formatTime(Math.round(myPlayer.howl.duration()));
                    //console.log(scope.totalDuration)
                    interval = setInterval(function () {
                        scope.getProgress();
                        scope.currentDuration = myPlayer.formatTime(Math.round(myPlayer.getCurrentDuration()));
                    }, 1000);
                }

                scope.pauseAudio = function () {
                    myPlayer && myPlayer.pause && myPlayer.pause();
                    clearInterval(interval);
                }

                scope.stopAudio = function () {
                    myPlayer && myPlayer.stop && myPlayer.stop();
                    scope.pl.show = false;
                }

                scope.$on('$destroy', function () {
                    scope.stopAudio()
                    // myPlayer && myPlayer.destroy && myPlayer.destroy();//causes error check why

                })

                scope.getProgress = function () {
                    scope.progress = myPlayer.getProgress();
                    scope.$apply();
                }

                scope.forward = function (event) {
                    var x = event.pageX - $(event.target).offset().left;
                    myPlayer.seek(x / (angular.element(document.getElementsByClassName('progressBar'))[0].offsetWidth));
                    scope.currentDuration = myPlayer.formatTime(Math.round(myPlayer.getCurrentDuration()));
                    scope.getProgress();
                }
            }
        }
    }])
    .directive('sidebarToTop', ["$window", function ($window) {
        return {
            link: function (scope, element, attrs) {
                angular.element($window).bind('scroll', function () {
                    var scrolltop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
                    //console.log(scrolltop)
                    if (scrolltop != 0) {
                        element.css({ top: Math.max(0, 87 - scrolltop) + 'px' });
                    }
                    else {
                        element.css({ top: '87px' });
                    }
                    scope.$apply();
                });
            }
        };
    }])
    .directive('ngEnter', function () {
        return function (scope, element, attrs) {
            element.bind("keydown keypress", function (event) {
                if (event.which === 13) {
                    scope.$apply(function () {
                        scope.$eval(attrs.ngEnter, { 'event': event });
                    });

                    event.preventDefault();
                }
            });
        };
    })
    .name;

// angular.module('agada').constant('NORMAL_STATE',1);
// angular.module('agada').constant('TABLET_STATE',2);
// angular.module('agada').constant('MOBILE_STATE',3);






//////////////////
// WEBPACK FOOTER
// ./public/js/directives/directives.js
// module id = 100
// module chunks = 0